var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(!_vm.isLoading)?_c('div',{staticClass:"flex flex-col"},[_c('Content'),_c('Navbar'),_c('Footer')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }